import { MsalService, // BroadcastService
 } from '@azure/msal-angular';
import { AccountInfo as MsalUser } from '@azure/msal-common';

export interface AuthState {
  authService: MsalService;
  // broadcastService: BroadcastService;
  loggedIn: boolean;
  userInfo: MsalUser;
}

export const initialAuthState: AuthState = {
  authService: null,
  // broadcastService: null,
  loggedIn: false,
  userInfo: null
};
